// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"5e25345a","498":"99e15fc2","598":"de2c081b","703":"26d244d5"}[chunkId] + ".chunk.js";
};